// OnboardingProgress Component
// Shows progress through onboarding steps

import React from 'react';
import styles from './OnboardingProgress.module.css';

const OnboardingProgress = ({ currentStep, totalSteps }) => {
  const steps = [
    { number: 1, label: 'Welcome' },
    { number: 2, label: 'Basic Info' },
    { number: 3, label: 'Athletic' },
    { number: 4, label: 'Bio' },
    { number: 5, label: 'Complete' }
  ];

  return (
    <div className={styles.container}>
      <div className={styles.header}>
        <span className={styles.stepText}>Step {currentStep} of {totalSteps}</span>
      </div>
      
      <div className={styles.progressBar}>
        <div 
          className={styles.progressFill}
          style={{ width: `${(currentStep / totalSteps) * 100}%` }}
        />
      </div>
      
      <div className={styles.steps}>
        {steps.map((step) => (
          <div
            key={step.number}
            className={`${styles.step} ${
              step.number === currentStep ? styles.active : ''
            } ${step.number < currentStep ? styles.completed : ''}`}
          >
            <div className={styles.stepCircle}>
              {step.number < currentStep ? '✓' : step.number}
            </div>
            <span className={styles.stepLabel}>{step.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default OnboardingProgress;















